import { z } from "zod";
/**
 * An origin-only URL — scheme + host (+ optional port), with no path, query, or fragment.
 *
 * Service clients build request paths against a base URL with `new URL("/abs/path", baseUrl)`,
 * which keeps only the base's origin and silently drops any path prefix, query, or fragment
 * (WHATWG relative resolution): a base of `https://gateway.example.com/service` would route every
 * request to `https://gateway.example.com/...`. Validating such bases as origin-only turns that
 * silent misrouting into a clear, up-front validation failure.
 */
export const originOnlyUrl = z.url().refine((value) => {
    let url;
    try {
        url = new URL(value);
    }
    catch {
        return false; // zod runs refinements even when z.url() already failed; it reports the format error
    }
    return url.pathname === "/" && !url.search && !url.hash;
}, "must be an origin without path, query, or fragment — URL resolution against it would silently drop them");
